import { Platform } from "react-native";

const isIPad =
  Platform.OS === "ios" && Platform.constants.interfaceIdiom === "pad";

export default isIPad;
